import type { SVGProps } from 'react';

const SvgAttachment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 21c-3.31 0-6-2.69-6-6V7.5C6 5.02 8.02 3 10.5 3S15 5.02 15 7.5V14c0 1.65-1.35 3-3 3s-3-1.35-3-3V8c0-.55.45-1 1-1s1 .45 1 1v6c0 .55.45 1 1 1s1-.45 1-1V7.5a2.5 2.5 0 0 0-5 0V15c0 2.21 1.79 4 4 4s4-1.79 4-4V8c0-.55.45-1 1-1s1 .45 1 1v7c0 3.31-2.69 6-6 6"
    />
  </svg>
);
export default SvgAttachment;
